<template>
  <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>增值税及附加税费申报表附列资料(三)<br />（服务、不动产和无形资产扣除项目明细）</dt>

      <dd>
        <div>纳税人名称（公章）：{{ staticConfig.companyName }}<br />（一般纳税人）</div>

        <div>税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}</div>

        <div>单位：元至角分</div>
      </dd>
    </dl>

    <div class="tax-table-body">
      <table>
        <thead>
          <tr>
            <td rowspan="3" colspan="2" class="td_height td_align">项目及栏次</td>
            <td rowspan="2" name="R0TD1" id="R0TD1" class="ts">本期服务、不动产和无形资产价税合计额（免税销售额）</td>
            <td colspan="5" class="td_height td_align">服务、不动产和无形资产扣除项目</td>
          </tr>
          <tr>
            <td class="td_height td_align">期初余额</td>
            <td name="R0TD3" id="R0TD3" class="td_height td_align">本期发生额</td>
            <td class="td_height td_align">本期应扣除金额</td>
            <td class="td_height td_align">本期实际扣除金额</td>
            <td class="td_height td_align">期末余额</td>
          </tr>
          <tr>
            <td class="td_height td_align" style="width: 100px">1</td>
            <td class="td_height td_align" style="width: 100px">2</td>
            <td class="td_height td_align" style="width: 100px">3</td>
            <td class="td_height td_align" style="width: 90px">4=2+3</td>
            <td class="td_height td_align" style="width: 100px">5(5≤1且5≤4)</td>
            <td class="td_height td_align" style="width: 90px">6=4-5</td>
          </tr>
        </thead>
        <tbody class="read-mode">
          <tr>
            <td width="120px;">13%税率的项目</td>
            <td width="30px;" class="td_height td_align">1</td>
            <td>
              <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v1x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v1x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v1x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v1x6.value) }}</td>
          </tr>
          <tr>
            <td class="td_height">9%税率的项目</td>
            <td class="td_height td_align">2</td>
            <td>
              <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v2x6.value) }}</td>
          </tr>
          <tr>
            <td class="td_height">6%税率的项目（不含金融商品转让）</td>
            <td class="td_height td_align">3</td>
            <td>
              <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v3x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v3x6.value) }}</td>
          </tr>
          <tr>
            <td class="td_height">6%税率的金融商品转让项目</td>
            <td class="td_height td_align">4</td>
            <td>
              <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v4x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v4x6.value) }}</td>
          </tr>
          <tr>
            <td class="td_height">5%征收率的项目</td>
            <td class="td_height td_align">5</td>
            <td>
              <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v5x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v5x6.value) }}</td>
          </tr>
          <tr>
            <td class="td_height">3%征收率的项目</td>
            <td class="td_height td_align">6</td>
            <td>
              <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v6x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v6x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v6x6.value) }}</td>
          </tr>
          <tr>
            <td class="td_height">免抵退税的项目</td>
            <td class="td_height td_align">7</td>
            <td>
              <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v7x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v7x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v7x6.value) }}</td>
          </tr>
          <tr>
            <td class="td_height">免税的项目</td>
            <td class="td_height td_align">8</td>
            <td>
              <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>
              <el-input-number v-model.trim="data.v8x3.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v8x4.value) }}</td>
            <td>
              <el-input-number v-model.trim="data.v8x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
            </td>
            <td>{{ parseFloatNum(data.v8x6.value) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="padding: 5px 0">
      <span style="font-size: 20px; color: red; margin-right: 5px; font-family: monospace">★</span>
      <span>温馨提示：销售额不包括销项税额（或应纳税额），纳税人采用销售额和销项税额合并定价方法的，按照下列公式计算销售额：销售额＝含税销售额÷（1+税率或征收率）</span>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

function watchStart() {
  watch(
    data,
    (newVal, oldVal) => {
      try {
        // 8行第4列第6列计算
        for (let row = 1; row <= 8; row++) {
          // 4=2+3
          data.value[`v${row}x4`].value = new Big(data.value[`v${row}x2`].value).plus(data.value[`v${row}x3`].value).round(2).toNumber();
          // 6=4-5
          data.value[`v${row}x6`].value = new Big(data.value[`v${row}x4`].value).minus(data.value[`v${row}x5`].value).round(2).toNumber();
        }
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss"></style>

<script>
const tableHtml = `
<table>
  <thead>
    <tr>
      <td rowspan="3" colspan="2" class="td_height td_align">项目及栏次</td>
      <td rowspan="2" name="R0TD1" id="R0TD1" class="ts">本期服务、不动产和无形资产价税合计额（免税销售额）</td>
      <td colspan="5" class="td_height td_align">服务、不动产和无形资产扣除项目</td>
    </tr>
    <tr>
      <td class="td_height td_align" style="width: 100px">期初余额</td>
      <td name="R0TD3" id="R0TD3" class="td_height td_align" style="width: 100px">本期发生额</td>
      <td class="td_height td_align" style="width: 120px">本期应扣除金额</td>
      <td class="td_height td_align" style="width: 130px">本期实际扣除金额</td>
      <td class="td_height td_align" style="width: 100px">期末余额</td>
    </tr>
    <tr>
      <td class="td_height td_align" style="width: 100px">1</td>
      <td class="td_height td_align">2</td>
      <td class="td_height td_align">3</td>
      <td class="td_height td_align">4=2+3</td>
      <td class="td_height td_align">5(5≤1且5≤4)</td>
      <td class="td_height td_align">6=4-5</td>
    </tr>
  </thead>
  <tbody class="read-mode">
    <tr>
      <td width="200px;">13%税率的项目</td>
      <td width="25px;" class="td_height td_align">1</td>
      <td>
        <div validate="data_1_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_1_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_1_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td width="200px;" class="td_height">9%税率的项目</td>
      <td width="25px;" class="td_height td_align">2</td>
      <td>
        <div validate="data_2_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_2_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_2_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td width="200px;" class="td_height">6%税率的项目（不含金融商品转让）</td>
      <td width="25px;" class="td_height td_align">3</td>
      <td>
        <div validate="data_3_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_3_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_3_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td width="200px;" class="td_height">6%税率的金融商品转让项目</td>
      <td width="25px;" class="td_height td_align">4</td>
      <td>
        <div validate="data_4_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_4_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_4_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td width="200px;" class="td_height">5%征收率的项目</td>
      <td width="25px;" class="td_height td_align">5</td>
      <td>
        <div validate="data_5_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_5_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_5_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td class="td_height" style="width: 350px">3%征收率的项目</td>
      <td width="25px;" class="td_height td_align">6</td>
      <td>
        <div validate="data_6_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_6_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_6_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_6_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td width="200px;" class="td_height">免抵退税的项目</td>
      <td width="25px;" class="td_height td_align">7</td>
      <td>
        <div validate="data_7_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_7_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_7_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_7_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
    <tr>
      <td width="200px;" class="td_height">免税的项目</td>
      <td width="25px;" class="td_height td_align">8</td>
      <td>
        <div validate="data_8_1" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_8_2" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div validate="data_8_3" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
      <td>
        <div validate="data_8_5" class="grid-input"><input type="text" autocomplete="off" /></div>
      </td>
      <td>
        <div class="grid-text"><span>0.00</span></div>
      </td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input type="text" autocomplete="off" \/>/g, '<el-input-number v-model.trim="defaultValueNum" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValueNum = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
